<div [@routeAnimations]="getRouteAnimationData()" class="bg-slate-300">
  <router-outlet></router-outlet>
</div>
@if (loading()) {
  <div
    class="layout-base fixed left-1/2 top-0 z-40 flex h-[100vh] w-full -translate-x-1/2 items-center justify-center bg-gray-600/30">
    <span class="loading loading-bars loading-lg text-primary"></span>
  </div>
}
<market-region-form-dialog />
